import controller from "emun.admin/admin-nav.controller";

//templates
import split from "emun.admin/admin-nav.split.htm";
import stacked from "emun.admin/admin-nav.stacked.htm";

export const templates = { split, stacked };

export default {
  controller,
  bindings: {
    headerText: "@",
    orientation: "@",
  },
  transclude: true,
  templateUrl($attrs) {
    const { type, layout = type } = $attrs;
    return $attrs.templateUrl ? $attrs.templateUrl : templates[layout] || split;
  },
};
